import { USER_PHASES } from '@interlayer/js/app/hooks/auth/constants';
import { send } from '@interlayer/js/hooks/socket';
import { IPlayerTag } from '@interlayer/js/hooks/user/store/buzz/types';

export const checkUsernameAvailability = (
    { email, casinoName, token }: { email: string; casinoName: string; token?: string }
) => send({
    ID: 31003,
    description: 'CheckUsernameAvailabilityRequest',
    responses: [31004, 31007],
    email,
    casinoName,
    token
}, true);

export const checkAccountBusinessPhase = ({
    businessPhase = [USER_PHASES.preRegistered, USER_PHASES.inShop],
    casinoName,
    field = ['email'],
    descriptionName = 'email',
    email = '',
    tokenCode = '',
    username = '',
    queryTimeout
}: {
    businessPhase?: string | string[];
    casinoName: string;
    field?: string[];
    descriptionName?: string;
    email?: string;
    tokenCode?: string;
    username?: string;
    queryTimeout?: number;
}) => send({
    ID: 31162,
    responses: [31163],
    description: `Search player by ${descriptionName}`,
    requestedPlayerData: {
        field,
        accountBusinessPhaseFilter: Array.isArray(businessPhase) ? businessPhase : [businessPhase]
    },
    searchCriteria: {
        casinoName,
        ...email ? { email } : {},
        ...tokenCode ? { tokenCode } : {},
        ...username ? { username } : {}
    },
    ...queryTimeout && { queryTimeout }
}, true);

export const getTerms = ({
    language,
    casinoName,
    clientPlatform,
    clientType,
    skin
}: {
    language: string;
    casinoName: string;
    clientPlatform: string;
    clientType: string;
    skin: string;
}) => send({
    ID: 35595,
    responses: [35596, 35597],
    description: 'Get Terms And Conditions File',
    language,
    casinoName,
    clientPlatform,
    clientType,
    skin,
    contentType: 'html',
    stringFormat: true
});

export const getAllPlayerTags = () => send({
    ID: 35547,
    description: 'Get all player tags',
    responses: [35548, 35549]
}, true);

export const removePlayerTags = (tags: IPlayerTag[]) => send({
    ID: 35553,
    description: 'Remove player tags',
    responses: [35554, 35555],
    tags
}, true);

export const checkPassword = ({ password }: { password: string }) => send({
    description: 'Check if password of current user is valid',
    password,
    ID: 35574,
    responses: [35575, 35576]
});
